// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-slide-toggle {
  margin: 0;
}
.modal-body .form-row {
  margin: 8px 0;
}
.modal-header {
  background-color: #0f1a35;
  color: white !important;
}
.modal-header .modal-title {
  font-size: 20px !important;
  font-weight: 600;
}
.modal-header .close {
  color: red;
  text-shadow: none;
  opacity: 1;
  font-size: 26px;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none;
  background: transparent;
  right: 20px;
  position: absolute;
}
.modal-footer {
  padding: 2px !important;
}
.bigAssModal .modal-dialog {
  max-width: 90% !important;
}
.modal-backdrop fade show {
  z-index: 55;
}
.mat-dialog-content {
  overflow: hidden;
}
.mat-dialog-content-step-1 {
  height: 85vh;
}
.locationContainer {
  max-height: 100%;
  height: 100%;
}
.listContainer {
  max-height: 100%;
  overflow: auto;
  border: solid 1px #ccc;
  min-height: 60px;
  background: white;
  border-radius: 4px;
}
.destinationContainer {
  background-color: #e2e7e2;
}
.location-box {
  padding: 20px 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  cursor: move;
  background: white;
  font-size: 14px;
}
location-box:last-child {
  border: none;
}
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.listContainer.cdk-drop-list-dragging .listContainer:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
`, "",{"version":3,"sources":["webpack://./src/assets/ngb-modals.less","webpack://./src/app/shared-components-module/payments/add-payment-group-modal/add-payment-group-modal.component.less"],"names":[],"mappings":"AAEA;EACE,SAAA;ACDF;ADGA;EACI,aAAA;ACDJ;ADIA;EACI,yBAAA;EACA,uBAAA;ACFJ;ADAA;EAKO,0BAAA;EACA,gBAAA;ACFP;ADJA;EASO,UAAA;EACC,iBAAA;EACA,UAAA;EACD,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;ACFP;ADMA;EACI,uBAAA;ACJJ;ADOA;EACI,yBAAA;ACLJ;AA3BA;EACE,WAAA;AA6BF;AA1BA;EACE,gBAAA;AA4BF;AAzBA;EACE,YAAA;AA2BF;AAxBA;EACE,gBAAA;EACA,YAAA;AA0BF;AAvBA;EACE,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAyBF;AAtBA;EACE,yBAAA;AAwBF;AArBA;EACE,kBAAA;EACA,6BAAA;EACA,0BAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAuBF;AApBA;EACE,YAAA;AAsBF;AAhBA;EACE,sBAAA;EACA,kBAAA;EACA,qHAAA;AAkBF;AATA;EACE,sDAAA;AAWF;AAPA;EACE,sDAAA;AASF","sourcesContent":["@import (reference) url('../styles.less');\n\nmat-slide-toggle {\n  margin: 0;\n}\n.modal-body .form-row{\n    margin: 8px 0;\n}\n\n.modal-header{\n    background-color: #0f1a35;\n    color: white !important;\n    \n    .modal-title{\n       font-size: 20px !important;\n       font-weight: 600;\n    };\n    .close{\n       color: red;\n        text-shadow: none;\n        opacity: 1;\n       font-size: 26px;\n       padding: 0 !important;\n       margin : 0 !important;\n       box-shadow: none;\n       background: transparent;\n       right: 20px;\n       position: absolute;\n    }\n}\n\n.modal-footer{\n    padding: 2px !important;\n}\n\n.bigAssModal .modal-dialog{\n    max-width: 90% !important;\n}","@import '../../../../assets/ngb-modals.less';\n\n// app-group-setup {\n\n.modal-backdrop fade show {\n  z-index: 55;\n}\n\n.mat-dialog-content {\n  overflow: hidden;\n}\n\n.mat-dialog-content-step-1 {\n  height: 85vh;\n}\n\n.locationContainer {\n  max-height: 100%;\n  height: 100%;\n}\n\n.listContainer {\n  max-height: 100%;\n  overflow: auto;\n  border: solid 1px #ccc;\n  min-height: 60px;\n  background: white;\n  border-radius: 4px;\n}\n\n.destinationContainer {\n  background-color: #e2e7e2;\n}\n\n.location-box {\n  padding: 20px 10px;\n  border-bottom: solid 1px #ccc;\n  color: rgba(0, 0, 0, 0.87);\n  cursor: move;\n  background: white;\n  font-size: 14px;\n}\n\nlocation-box:last-child {\n  border: none;\n}\n\n\n// }\n\n.cdk-drag-preview {\n  box-sizing: border-box;\n  border-radius: 4px;\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n  0 8px 10px 1px rgba(0, 0, 0, 0.14),\n  0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.cdk-drag-placeholder {\n  //opacity: 0;\n}\n\n.cdk-drag-animating {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n\n.listContainer.cdk-drop-list-dragging .listContainer:not(.cdk-drag-placeholder) {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
